import { useActive, useCommands } from '@remirror/react';
import React, { FC, useCallback } from 'react';
import { CommandButton, ICommandButtonProps } from '../../../components';
import { WFormatSuperscriptExtension } from '../WFormatSuperscriptExtension';

export type IToggleWFormatSuperscriptButtonProps = Omit<
  ICommandButtonProps,
  'commandName' | 'active' | 'enabled' | 'attrs' | 'onSelect'
>;

export const ToggleWFormatSuperscriptButton: FC<IToggleWFormatSuperscriptButtonProps> = (props) => {
  const type = 'superscript';
  const { toggleWFormatSuperscript: command, focus } = useCommands<WFormatSuperscriptExtension>();
  const active = useActive<WFormatSuperscriptExtension>().wFormatSuperscript({
    type,
  });
  const enabled = command.enabled({ type });

  const handleClick = useCallback(() => {
    if (enabled) {
      command({ type });
      focus();
    }
  }, [command]);

  return (
    <CommandButton
      {...props}
      commandName="toggleWFormatSuperscript"
      active={active}
      enabled={enabled}
      onSelect={handleClick}
    />
  );
};
